export default __webpack_public_path__ + "static/media/growth-icon.fbd2213e.svg";